import { postRequest } from "./ApiInstence";

export const shiprocketLogin = async (options = {}) => {
  const payload = {};
  if (options.email) payload.email = options.email;
  if (options.password) payload.password = options.password;
  if (typeof options.force !== "undefined") payload.force = Boolean(options.force);
  return postRequest("shiprocket/login", payload);
};

export const shiprocketInvoice = async (input) => {
  if (input && typeof input === "object" && !Array.isArray(input)) {
    return postRequest("shiprocket/invoice", input);
  }
  const list = Array.isArray(input) ? input : [input];
  const cleanIds = list.filter(
    (id) => id !== undefined && id !== null && String(id).trim() !== ""
  );
  if (cleanIds.length === 1) {
    return postRequest("shiprocket/invoice", { id: cleanIds[0] });
  }
  return postRequest("shiprocket/invoice", { ids: cleanIds });
};

export default shiprocketLogin;
